import type { EditionDefinition } from '@/editions/types';

/**
 * Soccer: technically the same pages as Fit (a team is a department, a
 * player a user — the API has one model), with its own section/item labels
 * (§ Wat Soccer nu inhoudt). Routes are shared with Fit on purpose, so a
 * link never needs to know which edition it is rendered under; only
 * `editions.soccer.*` in the catalogues differs.
 */
export const soccer: EditionDefinition = {
  id: 'soccer',
  sections: [
    {
      id: 'home',
      labelKey: 'editions.soccer.sections.home',
      to: '/departments',
      match: ['/departments', '/users'],
      visible: (p) => p.canSeeDepartmentsSection || p.canSeeUsersSection,
      items: [
        {
          id: 'departments',
          labelKey: 'editions.soccer.items.departments',
          to: '/departments',
          visible: (p) => p.canSeeDepartmentsSection,
        },
        {
          id: 'users',
          labelKey: 'editions.soccer.items.users',
          to: '/users',
          visible: (p) => p.canSeeUsersSection,
        },
      ],
    },
  ],
};
